'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardText = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 0;\n  margin-bottom: 1rem;\n  &:last-child {\n    margin-bottom: 0;\n  };\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  margin-top: 0;\n  margin-bottom: 1rem;\n  &:last-child {\n    margin-bottom: 0;\n  };\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require('styled-system');

var _styledBaseComponents = require('styled-base-components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var CardText = exports.CardText = (0, _styledComponents2.default)(_styledBaseComponents.P)(_templateObject, _styledSystem.space, _styledSystem.width, _styledSystem.color, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.textAlign, _styledSystem.lineHeight, _styledSystem.display, _styledSystem.borderRadius, _styledSystem.borderColor, _styledSystem.borders);